import ApiRequest from '../../utils/ApiRequest';
import { SessionInitiationResponse } from '../../types/api/publicEnrollment/SessionInitiationResponse';

export async function initiatePublicEnrollmentSession(publicId: string) {
    const result = await ApiRequest.post<SessionInitiationResponse>(`public-enrollment/initiate/${publicId}`);
    return result;
}